<template>
    <section class="gmp-section gmp-mb-xl">
        <div class="gmp-section-header ">
            <div class="h-c-page">
                <div class="h-c-grid">
                    <div class="h-c-grid__col">
                        <h3 class="h-c-headline h-c-headline--one gmp-section-header--center">
                            餐饮供货解决方案
                        </h3>
                    </div>
                </div>
            </div>
        </div>

        <div class="h-c-page">
            <div class="product-tout product-tout--narrow">
                <div class="product-tout__content">

                    <div class="product-tout__icon">
                        <picture>
                            <img src="@/assets/img/4a.png" alt="" class="">
                        </picture>
                    </div>
                    <div class="product-tout__copy">
                        <h4 class="h-c-headline product-tout__headline">
                            批发市场专业配送商
                        </h4>
                        <p class="h-c-headline h-c-headline--four">
                            快速处理订单并提供准确的分拣和称重服务。
                        </p>
                    </div>
                    <div class="product-tout__link">
                        <a @click="toMarketDistributor('/market/distributor','批发市场专业配送商')" class="h-c-link h-c-link--internal gmp-link">
                            查看更多专业配送
                        </a>
                    </div>
                </div>

                <div class="product-tout__image">
                    <img src="@/assets/img/pro_dis.png" alt="" class="gmp-no-grab ">
                </div>
            </div>
        </div>

        <div class="product-card-grid">
            <div class="h-c-page">
                <div class="glue-pagination h-c-carousel h-c-carousel--tile h-c-carousel--tile-small-only h-u-mt-std ng-isolate-scope glue-o-pagination">
                    <div class="h-c-carousel__wrap product-card-grid__wrap--narrow ng-scope">
                        <ul class="abc"  >
                            <li class="aaa">
                                <a  @click="toGoods('/market/goods','单品供货商')"  class="h-c-tile h-c-tile--border h-c-tile--hoverable h-c-tile--small-height">
                                    <div class="h-c-tile__header h-c-tile__header--icon product-card__header">
                                        <picture>
                                            <img src="@/assets/img/a-bianzu6.png" alt=""
                                                 class="gmp-product-icon gmp-product-icon--fixed">
                                        </picture>
                                    </div>

                                    <div class="h-c-tile__body">
                                        <h4 class="h-c-tile__headline product-card__headline">
                                           单品配送商
                                        </h4>
                                        <p class="h-c-tile__description">
                                            确保各门店的操作一致性，提高整个连锁的管理效率.
                                        </p>

                                        <ul class="h-c-tile__links">
                                            <li class="h-c-tile__link">
                                                <img src="@/assets/img/arrow-right.png" alt=""
                                                     class="h-c-tile__link h-c-tile__link--arrow">
                                            </li>
                                        </ul>
                                    </div>

                                </a>
                            </li>


                            <li class="aaa   h-c-carousel__item product-card product-card--hide-for-large">
                                <a @click="toMarketDistributor('/market/distributor','批发市场专业配送商')"  class="h-c-tile h-c-tile--border h-c-tile--hoverable h-c-tile--small-height">
                                    <div class="h-c-tile__header h-c-tile__header--icon product-card__header">
                                        <picture>
                                            <img src="@/assets/img/a-bianzu48.png" alt=""
                                                 class="gmp-product-icon gmp-product-icon--fixed">
                                        </picture>
                                    </div>

                                    <div class="h-c-tile__body">
                                        <h4 class="h-c-tile__headline product-card__headline">
                                            批发市场专业配送商
                                        </h4>
                                        <p class="h-c-tile__description">
                                            快速处理订单并提供准确的分拣和称重服务
                                        </p>

                                        <ul class="h-c-tile__links">
                                            <li class="h-c-tile__link">
                                                <img src="@/assets/img/arrow-right.png" alt=""
                                                     class="h-c-tile__link h-c-tile__link--arrow">
                                            </li>
                                        </ul>
                                    </div>
                                </a>
                            </li>

                            <li class="aaa">
                                <a @click="toPlatform('/market/platform','生鲜配送平台')"  class="h-c-tile h-c-tile--border h-c-tile--hoverable h-c-tile--small-height">
                                    <div class="h-c-tile__header h-c-tile__header--icon product-card__header">
                                        <picture>
                                            <img src="@/assets/img/a-bianzu48.png" alt=""
                                                 class="gmp-product-icon gmp-product-icon--fixed">
                                        </picture>
                                    </div>

                                    <div class="h-c-tile__body">
                                        <h4 class="h-c-tile__headline product-card__headline">
                                            生鲜配送平台
                                        </h4>
                                        <p class="h-c-tile__description">
                                            帮助加盟者轻松遵循品牌标准，同时能够根据各自市场的需求进行适当调整.
                                        </p>

                                        <ul class="h-c-tile__links">
                                            <li class="h-c-tile__link">
                                                <img src="@/assets/img/arrow-right.png" alt=""
                                                     class="h-c-tile__link h-c-tile__link--arrow">
                                            </li>
                                        </ul>
                                    </div>
                                </a>
                            </li>

                            <div style="clear:both;"></div>
                        </ul>

                    </div>



                </div>


            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "M_Product",

        data() {
            return {

            }
        },
        mounted() {


        },

        methods:{
            toMarketDistributor(data, hanzi) {
                this.$router.push(data)
                this.isShowDrawer = false;
                this.$('body').removeClass('h-is-showing-drawer');

                this.$('.h-c-header__drawer-nav-list').remove()
                this.$('.h-c-header').addClass('h-c-header--product-initiative').removeClass('h-c-header--product-marketing-one-tier');

                var hasAdd = this.$('.h-c-header__initiative-logo');
                if (hasAdd.length === 0) {
                    var data1 = `<div class="h-c-header__initiative-logo">
                                    <a   class="h-c-header__initiative-logo-link">
                                        <span class="h-c-header__initiative-logo-text">` + hanzi + `</span>
                                    </a>
                                 </div>`
                    this.$('.h-c-header__bar').append(data1);

                    var data2 = `<div class="h-c-header__drawer-initiative-logo">
                                     <div class="h-c-header__drawer-initiative-logo-link">
                                        <span class="h-c-header__drawer-initiative-logo-text">` + hanzi + `</span>
                                     </div>
                                 </div>`;
                    this.$('.h-c-header__drawer-bar').append(data2)
                }


                var data3 = `<ul class="h-c-header__drawer-nav-list">
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link h-is-active " to-where="` + data + `">概览</a>
                                </li>
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link "  to-where="` + data + `/DIS_Benefit">好处</a>
                                </li>
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link"  to-where="` + data + `/DIS_Special">特点</a>
                                </li>
                              </ul>`;
                this.$('.h-c-header__drawer-nav').append(data3)


                let that = this;
                var x = document.querySelectorAll('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < x.length; i++) {
                    x[i].addEventListener('click', function () {
                        that.toEnterprisePage(this.getAttribute('to-where'))
                    })
                }
            },


            //
            toGoods(data, hanzi) {
                this.$router.push(data)
                this.isShowDrawer = false;
                this.$('body').removeClass('h-is-showing-drawer');

                this.$('.h-c-header__drawer-nav-list').remove()
                this.$('.h-c-header').addClass('h-c-header--product-initiative').removeClass('h-c-header--product-marketing-one-tier');

                var hasAdd = this.$('.h-c-header__initiative-logo');
                if (hasAdd.length === 0) {
                    var data1 = `<div class="h-c-header__initiative-logo">
                                    <a   class="h-c-header__initiative-logo-link">
                                        <span class="h-c-header__initiative-logo-text">` + hanzi + `</span>
                                    </a>
                                 </div>`
                    this.$('.h-c-header__bar').append(data1);

                    var data2 = `<div class="h-c-header__drawer-initiative-logo">
                                     <div class="h-c-header__drawer-initiative-logo-link">
                                        <span class="h-c-header__drawer-initiative-logo-text">` + hanzi + `</span>
                                     </div>
                                 </div>`;
                    this.$('.h-c-header__drawer-bar').append(data2)
                }


                var data3 = `<ul class="h-c-header__drawer-nav-list">
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link h-is-active " to-where="` + data + `">概览</a>
                                </li>
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link "  to-where="` + data + `/GOODS_Benefit">好处</a>
                                </li>
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link"  to-where="` + data + `/GOODS_Special">特点</a>
                                </li>
                              </ul>`;
                this.$('.h-c-header__drawer-nav').append(data3)


                let that = this;
                var x = document.querySelectorAll('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < x.length; i++) {
                    x[i].addEventListener('click', function () {
                        that.toEnterprisePage(this.getAttribute('to-where'))
                    })
                }
            },
            //
            toPlatform(data, hanzi) {
                this.$router.push(data)
                this.isShowDrawer = false;
                this.$('body').removeClass('h-is-showing-drawer');

                this.$('.h-c-header__drawer-nav-list').remove()
                this.$('.h-c-header').addClass('h-c-header--product-initiative').removeClass('h-c-header--product-marketing-one-tier');

                var hasAdd = this.$('.h-c-header__initiative-logo');
                if (hasAdd.length === 0) {
                    var data1 = `<div class="h-c-header__initiative-logo">
                                    <a   class="h-c-header__initiative-logo-link">
                                        <span class="h-c-header__initiative-logo-text">` + hanzi + `</span>
                                    </a>
                                 </div>`
                    this.$('.h-c-header__bar').append(data1);

                    var data2 = `<div class="h-c-header__drawer-initiative-logo">
                                     <div class="h-c-header__drawer-initiative-logo-link">
                                        <span class="h-c-header__drawer-initiative-logo-text">` + hanzi + `</span>
                                     </div>
                                 </div>`;
                    this.$('.h-c-header__drawer-bar').append(data2)
                }


                var data3 = `<ul class="h-c-header__drawer-nav-list">
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link h-is-active " to-where="` + data + `">概览</a>
                                </li>
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link "  to-where="` + data + `/PL_Benefit">好处</a>
                                </li>
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link"  to-where="` + data + `/PL_Special">特点</a>
                                </li>
                              </ul>`;
                this.$('.h-c-header__drawer-nav').append(data3)


                let that = this;
                var x = document.querySelectorAll('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < x.length; i++) {
                    x[i].addEventListener('click', function () {
                        that.toEnterprisePage(this.getAttribute('to-where'))
                    })
                }
            },
        },


    }
</script>

<style lang="less">


    .abc{
        position: relative;
    }
    

</style>